import { css } from 'styled-components';

import { Skin } from '#src/__generated__/globalTypes.ts';

export const skinEditionGradient = css`
  &.shiny {
    background: var(--c-gradient-shiny);
  }
  &.holo {
    background: var(--c-gradient-holo);
  }
  &.full_art {
    background: var(--c-gradient-legendary);
  }
`;

export const skinEditionChipBackground = css`
  &.shiny,
  &.holo,
  &.full_art {
    padding: 2px;
    border: none;
  }

  ${skinEditionGradient}
`;

export const skinEditionChipClassName = (
  skin: Nullable<Skin>
): string | undefined =>
  skin && skin !== Skin.STANDARD ? skin.toLowerCase() : undefined;
